import { isNativeApp } from '../native/platform'
import { setCredential } from '../native/credentialStore'

/**
 * [Native B1, NB1-1/NB1-2] Persist the `gs_` token a native-origin redeem / redeem-code / enroll
 * returns — ONLY to OS secure storage, never localStorage (the `canvasser_grant` mirror stays
 * ids-only). Web: a no-op; the HttpOnly cookie carries the session. Must complete before any
 * follow-up grant request (e.g. `/grant/me`) so that request carries the new bearer.
 */
export async function storeGrantSessionToken(identity: { sessionToken?: string | null }): Promise<void> {
  if (!isNativeApp() || !identity.sessionToken) return
  await setCredential('grant', identity.sessionToken)
}
